import { added } from "../actions";

const addBooks = (name, author, thumbnail, price, rating, featured) => {
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books", {
      method: "POST",
      body: JSON.stringify({
        name,
        author,
        thumbnail,
        price,
        rating,
        featured,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const book = await response.json();
    dispatch(
      added(
        book.name,
        book.author,
        book.thumbnail,
        book.price,
        book.rating,
        book.featured
      )
    );
  };
};
export default addBooks;
